import types, { STATION_SCOPED_FETCH_IDS } from '../constants'

const isResponse = (type) =>
  type.endsWith('_SUCCESS') || type.endsWith('_FAILURE')

// Stamps station-scoped $payload requests with the current station epoch and
// drops their _SUCCESS/_FAILURE if the station was switched while in flight.
// Must sit before redux-fetch-middleware so the stamp ends up in response meta.
export const createStationScopeMiddleware = () => {
  let epoch = 0

  return () => (next) => (action) => {
    if (!action || !action.type) return next(action)

    if (action.type === types.SWITCH_STATION) {
      epoch += 1
      return next(action)
    }

    const meta = action.meta
    if (!meta || STATION_SCOPED_FETCH_IDS.indexOf(meta.fetch_id) === -1)
      return next(action)

    if (action.$payload)
      return next({ ...action, meta: { ...meta, $stationEpoch: epoch } })

    if (
      isResponse(action.type) &&
      meta.$stationEpoch !== undefined &&
      meta.$stationEpoch !== epoch
    )
      return undefined

    return next(action)
  }
}

export default createStationScopeMiddleware()
